import { Container } from "react-bootstrap";
import { Col, Row } from "react-bootstrap";
import React from "react";
import "./body.styles.css";
import DoctorImage from "../../assets/doctor-with-quote.svg";
import PENT from "../../assets/PENT.svg"
import AST from "../../assets/AST.svg"
import MIS from "../../assets/MIS.svg"
import ET from "../../assets/ET.svg"
import SA from "../../assets/SA.svg"
import HIE from "../../assets/HIE.svg"

export default function Body() {
  return (
    <div className="body-container" id="about">
      <Container>
        <Row>
          <Col md={4}>
            <div className="doctor-image-container">
              <img src={DoctorImage} className="doctor-image" alt="AM" />
            </div>
          </Col>
          <Col md={8}>
            <div className="doctor-name-heading">
              About <span style={{ color: "#F8C28F" }}>Dr. Aashima Chopra</span>
            </div>
            <div className="doctor-description-top">
              Dr. Aashima is a versatile ENT surgeon with 8 years of experience under her belt. A GOLD medallist of her batch, she is experienced in the latest advances in the field including endoscopic and minimally invasive ear surgeries.
            </div>
            <div className="doctor-description-top">
              After graduating from the prestigious Institute of Medical sciences in the country-MAHE and then got awarded GOLD for being the best in the batch in her PG from the National board of examinations. She has dedicated her learning to serve her patients with the most advanced and trusted medical knowledge.
            </div>
          </Col>
        </Row>
      </Container>
      <Container className="area-of-expertise-container">
        <div className="area-of-expertise">Areas of expertise</div>
        <Row className="aoe-top-row" style={{ marginTop: "8rem" }}>
          <Col md={4} className="expertise_div">
            <div>
              <div>
                <img src={SA} alt="SA" />
              </div>
            </div>
            <div className="aoe-image-title">Sleep apnoea</div>
          </Col>
          <Col md={4} className="expertise_div">
            <div>
              <div>
                <img src={HIE} alt="HIE" />
              </div>
            </div>
            <div className="aoe-image-title">Hearing loss evaluation</div>
          </Col>
          <Col md={4} className="expertise_div">
            <div>
              <div>
                <img src={PENT} alt="PENT" />
              </div>
            </div>
            <div className="aoe-image-title">Paediatric ENT</div>
          </Col>
        </Row>
        <Row className="aoe-bottom-row" style={{ marginTop: "8rem" }}>
          <Col md={4} className="expertise_div">
            <div>
              <div>
                <img src={ET} alt="ET" />
              </div>
            </div>
            <div className="aoe-image-title">Emergency Treatment</div>
          </Col>
          <Col md={4} className="expertise_div">
            <div>
              <div>
                <img src={AST} alt="AST" />
              </div>
            </div>
            <div className="aoe-image-title">Allergic and Sinusitis Treatment</div>
          </Col>
          <Col md={4} className="expertise_div">
            <div>
              <div>
                <img src={MIS} alt="MIS" />
              </div>
            </div>
            <div className="aoe-image-title">Minimally invasive surgeries</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
